<template>
  <div class="col-md-3">
    <form-group-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="necessidadesOption || []"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  name: "c-necessidade-especial",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    login: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      necessidadesOption: [
        {
          value: "Não",
          text: `Não`
        },
        {
          value: "Deficiência Física",
          text: `Deficiência Física`
        },
        {
          value: "Visual",
          text: `Visual`
        },
        {
          value: "Auditiva",
          text: `Auditiva`
        },
        {
          value: "Intelectual",
          text: `Intelectual`
        },
        {
          value: "Múltipla",
          text: `Múltipla`
        },
        {
          value: "Transtorno do espectro autista",
          text: `Transtorno do espectro autista`
        },
        {
          value: "Transtorno de déficit de atenção",
          text: `Transtorno de déficit de atenção`
        },
        {
          value: "Hiperatividade",
          text: `Hiperatividade`
        },
        {
          value: "Dislexia",
          text: `Dislexia`
        }
      ]
    };
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Crm/NecessidadeEspecial.vue